module.exports = __webpack_public_path__ + "static/media/viviendasPiraino.81f66e6d.mp3";